import React from 'react';
import styled from 'styled-components/macro';
import { TopVariantsTooltipWrapper } from '../dashboard/main/widgets/styles/topVariants';
import { IMapperData } from './types';

const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const Icon = styled.div`
  width: 24px;
  height: 24px;
  background: ${props => props.color};
  border-radius: 5px;
  margin-right: 8px;
`;

const LegendPercentage = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #272a32;
  width: 30px;
`;

const LegendName = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #272a32;
`;

const LegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CustomLegend = (props: { data: IMapperData['data'] }) => {
  const { data } = props;

  return (
    <>
      {data.map(entry => (
        <TopVariantsTooltipWrapper>
          <LegendContainer key={entry.id}>
            <Icon color={entry.color} />

            <LegendWrapper>
              <LegendPercentage>{entry.value}</LegendPercentage>
              <LegendName>{entry.name}</LegendName>
            </LegendWrapper>
          </LegendContainer>
        </TopVariantsTooltipWrapper>
      ))}
    </>
  );
};

export default CustomLegend;
